import firebaseApp from "../firebase/credenciales";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import Swal from 'sweetalert2'
import escribirLog from "./escribirLog";

export default async function uploadDocumento(documentoLocal, ruta, nombre, autor) {
  const storage = getStorage(firebaseApp);
  //Subir archivo firebase storage
  const docuRef = ref(storage, ruta);
  await uploadBytes(docuRef, documentoLocal);
  // Escuchamos los cambios de estado, los errores y la finalización de la carga.

  //Obtener url de descarga
  const url = getDownloadURL(docuRef);

  if((await url).substring(0, 23) === "https://firebasestorage"){
    //registro concluido
    Swal.fire({
      position: 'top-end',
      icon: 'success',
      title: 'Documento subido correctamente',
      showConfirmButton: false,
      timer: 2500
    })

    } else {
      //registro concluido
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Error al subir el documento',
        showConfirmButton: false,
        timer: 2500
      })
    }

  escribirLog("Upload", nombre, autor);

  return url;
}

